import script from "./Dashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=1bc30d87&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bc30d87"]])

export default __exports__